<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Bitiş')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (selectedCurrent = e)"
          :label="'Cari'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="salesPersonCode"
          label="Plasiyer"
          filled
          solo
          dense
          clearable
          :items="salesPersonList"
          :item-text="item => item.name"
          :item-value="item => item.code"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue"
          label="Grup Kodu"
          :items="[
            {value: 1, text: 'GRUP KODU'},
            {value: 2, text: 'KOD 1'},
            {value: 3, text: 'KOD 2'},
            {value: 4, text: 'KOD 3'},
            {value: 5, text: 'KOD 4'},
            {value: 6, text: 'KOD 5'}
            ]"
          item-text="text"
          item-value="value"
          filled
          solo
          dense
          clearable
          @change="getCodesList"
          :error-messages="
                      validationMessages($v.groupCodeValue, 'Grup Kodu')
                    "
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupValue"
          label="Grup Değeri"
          :items="groupValueList"
          item-value="code"
          item-text="name"
          filled
          clearable
          solo
          dense
          :error-messages="
                      validationMessages($v.groupValue, 'Grup Değeri')
                    "
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="reportDbName"
          label="Şirket Adı"
          filled
          solo
          dense
          clearable
          :items="companyList"
          item-text="name"
          item-value="name"
      >

      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import { mapActions,mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  name: "EnIyiSatis",
  components: {SearchSelect},
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      reportDbName: null,
      groupCodeValue: null,
      selectedCurrent: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult:[],
      searchCurrentTimeout: null,
      salesPersonCode: null,
      groupValueList: [],
      groupValue: null
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
    groupCodeValue: {
      required,
    },
    groupValueList: {
      required,
    },
    groupValue: {
      required,
    }
  },

  mounted() {
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    });
    this.fetchCompanyList({
      params: {

      },
      body: {

      }
    });
  },
  computed:{
    ...mapState("current",["salesPersonList"]),
    ...mapState("company",["companyList"]),
    ...mapState("auth",["user"])
  },
  methods:{
    ...mapActions("current", ["fetchSalesPersonList","fetchCurrentList"]),
    ...mapActions("company", ["fetchCompanyList"]),
    ...mapActions("stock", ["fetchStockCodes"]),
    validationMessages,
    formattedDate,
    async getCodesList(){
      let requestParams = {};
      requestParams.params = {tableType: this.groupCodeValue};
      requestParams.body = {}
      let result = await this.fetchStockCodes(requestParams);
      this.groupValueList = result;
    },
    filterReport(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          CodeType: this.groupCodeValue,
          CodeValue: this.groupValue,
          CurrentCode: this.selectedCurrent,
          SalesPersonCode: this.salesPersonCode,
          ReportDbName: this.reportDbName
        };
        this.$emit("reportFilterChange",this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
    async searchCurrentList() {
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId : this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
          ...(this.currentSearchText == "" || this.currentSearchText == null  ? false : true) && {searchText: this.currentSearchText }
        },
        body: {

        },
        onlyData: true,
        loading: false
      });
      this.searchCurrentLoading = false

    }
  },
  watch:{
    currentSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        if(this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {

          this.searchCurrentList();
        },3000);
      }
      else
      {
        this.searchCurrentLoading = false;
        if(this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
      }
    }
  }

}
</script>

<style scoped>

</style>